import { render } from "./MenuSeparator.vue?vue&type=template&id=8f0ebeb2"
import script from "./MenuSeparator.vue?vue&type=script&lang=js"
export * from "./MenuSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MenuSeparator.vue"]])

export default __exports__